import { SxProps, Theme } from '@mui/material';

type StylesConfig = {
  toggle: SxProps<Theme>;
};

const styles: StylesConfig = {
  // The toggle sits in a wrapping filter row: on phones it takes a row of its
  // own above the filters, from `sm` up it ends the row on the right.
  toggle: {
    order: { xs: -1, sm: 0 },
    flex: { xs: '1 0 100%', sm: '0 0 auto' },
    marginLeft: { sm: 'auto' },
  },
};

export default styles;
